import ExamplePost1 from "./example_post_1.md";

/* eslint-disable @typescript-eslint/no-explicit-any*/
export const posts: { [key: string]: any } = {
  example_post_1: ExamplePost1,
};
